module.exports = __webpack_public_path__ + "img/33_59.b8ccff68.png";